import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { Concession } from '../../lib/api';

interface DeviationDetailsProps {
  concession: Concession;
}

export function DeviationDetails({ concession }: DeviationDetailsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Deviation Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-muted-foreground">Part Number</Label>
            <p className="font-mono font-medium">{concession.part_number}</p>
          </div>
          <div>
            <Label className="text-muted-foreground">Quantity Affected</Label>
            <p className="font-medium">{concession.quantity_affected} {concession.unit_of_measure}</p>
          </div>
          <div>
            <Label className="text-muted-foreground">Deviation Type</Label>
            <p className="font-medium capitalize">{concession.deviation_type}</p>
          </div>
          <div>
            <Label className="text-muted-foreground">Batch Number</Label>
            <p className="font-medium">{concession.batch_number || 'N/A'}</p>
          </div>
        </div>

        <div>
          <Label className="text-muted-foreground">Description</Label>
          <p className="mt-1 whitespace-pre-wrap">{concession.description}</p>
        </div>

        <div>
          <Label className="text-muted-foreground">Reason for Request</Label>
          <p className="mt-1 whitespace-pre-wrap">{concession.reason}</p>
        </div>

        {concession.proposed_disposition && (
          <div>
            <Label className="text-muted-foreground">Proposed Disposition</Label>
            <p className="mt-1 whitespace-pre-wrap">{concession.proposed_disposition}</p>
          </div>
        )}

        {concession.risk_justification && (
          <div>
            <Label className="text-muted-foreground">Risk Justification</Label>
            <p className="mt-1 whitespace-pre-wrap">{concession.risk_justification}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
